<template>
  <div class="w-full mt-4" >
    <EuiGridRow>
      <EuiHeading :level="3" class="flex w-full">
        <div> Le {{ localeToDisplay}}</div>
      </EuiHeading>
    </EuiGridRow>
    <EuiGridRow>
      <traceArea
        :id="`${content._id}`"
        :message="content.message"
        :error="content.has_error"
        :rows="10"
      />
    </EuiGridRow>
  </div>
</template>

<script>
import dates from '@/mixins/dates';
import traceArea from '@/components/logs/traceArea.vue';

export default {
  name: 'components.logs.log_card',
  mixins: [dates],
  components: {
    traceArea,
  },
  props: {
    content: Object,
  },
  computed: {
    localeToDisplay() {
      const d = (this.content.timestampLogs)
        ? new Date(this.content.timestampLogs)
        : new Date(this.content.timestamp);
      return d.toLocaleString('fr-FR');
    },
  },
};
</script>
